import type {
  AutonomousAgentConversationResponse,
  AutonomousAgentQueryRequest,
  InitializeAutonomousAgentConversationRequest,
} from 'api/types';
import { addWidgetComponents } from 'reducers/workflows';
import ApiService from 'services/ApiService';
import { createAppAsyncThunk } from 'createAppAsyncThunk';
import { postMessage } from 'utils/postMessage';
import { rejectWithCustomFetchError } from 'api/customFetch';

export const initAutonomousAgentConversation = createAppAsyncThunk<
  AutonomousAgentConversationResponse,
  InitializeAutonomousAgentConversationRequest
>(
  'workflows/initAutonomousAgentConversation',
  async (data, { dispatch, rejectWithValue }) => {
    dispatch(
      addWidgetComponents([
        {
          component_fields: { message: data.free_form_query },
          component_type: 'text_message',
          isSent: true,
        },
      ]),
    );
    postMessage({
      event: 'autonomousAgentConversationUpdated',
      userQuery: data.free_form_query,
    });
    try {
      const res = await ApiService.request(
        'init-autonomous-agent-conversation',
        {
          data,
        },
      );
      return res;
    } catch (error) {
      return rejectWithCustomFetchError(error, rejectWithValue);
    }
  },
);

export const autonomousAgentQuery = createAppAsyncThunk<
  AutonomousAgentConversationResponse,
  { conversationId: string; data: AutonomousAgentQueryRequest }
>(
  'workflows/autonomousAgentQuery',
  async ({ conversationId, data }, { dispatch, rejectWithValue }) => {
    dispatch(
      addWidgetComponents([
        {
          component_fields: { message: data.query },
          component_type: 'text_message',
          isSent: true,
        },
      ]),
    );
    postMessage({
      event: 'autonomousAgentConversationUpdated',
      userQuery: data.query,
    });

    try {
      const res = await ApiService.request('autonomous-agent-query', {
        data,
        urlValues: {
          conversationId,
        },
      });

      return res;
    } catch (error) {
      return rejectWithCustomFetchError(error, rejectWithValue);
    }
  },
);
